import { Form, Input, Modal, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import Presets from "../../extensions/presets";
import { useSelector } from "react-redux";
import { serverFetch } from "../../server";
import { allExpanded, defaultStyles, JsonView } from "react-json-view-lite";

const LogUserItem = ({...props}) => {
    const user = useSelector((s) => s.user);
    const { id, onClose } = props;
    const [item, setItem] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        serverFetch(`LogUser/${id}`, {method: 'GET'}, user)
            .then(data => {
                setLoading(false);
                setItem(data);
            })
            .catch((e) => {
                setLoading(false);
                message.error (`Ошибка`);
                console.log(e);
            })
    }, [id, user]);      
    
    const strIsJson = (value) => value && value.charAt(0) === "{"
    const strIsHtml = (value) => value && value.substring(0,15) === "<!doctype html>"

    const getStringView = (value) => {
        if (!value)
            return<div />
        if (strIsJson(value))
            return <JsonView data={JSON.parse(value)} shouldExpandNode={allExpanded} style={defaultStyles} clickToExpandNode/>
        if (strIsHtml(value))
            return <div dangerouslySetInnerHTML={{ __html: value }} style={{border: "1px solid gray", borderRadius: 8}}/>
        return <TextArea autoSize={{ minRows: 4}} value={value} />
    }    
    
    const divContent = getStringView(item?.contentData); // strIsJson(item?.contentData) ?  : <TextArea autoSize={{ minRows: 4}} value={item?.contentData} />
    const divResult  = getStringView(item?.resultData); // strIsJson(item?.resultData) ? <ReactJson src={JSON.parse(item?.resultData)} collapsed={true}/> : <TextArea autoSize={{ minRows: 4}} value={item?.resultData} />
    return <Modal {...Presets.modalInfo} title="Запись" width={800} onCancel={() => onClose()}>
        <Form colon={false} disabled={loading} readOnly={true}>
            <Form.Item><Input value={item?.id} style={{width: 200}}/></Form.Item>
            <Form.Item label="Запрос" />
            <Form.Item>{divContent}</Form.Item>
            <Form.Item label="Ответ" />
            <Form.Item>{divResult}</Form.Item>
        </Form>
    </Modal>
}

export default LogUserItem;